export const GOAL_DIRECTORY_SORTS_AGG = [
	'NAME_ASC',
	'NAME_DESC',
	'SCORE_ASC',
	'SCORE_DESC',
	'TARGET_DATE_ASC',
	'TARGET_DATE_DESC',
	'WATCHING_ASC',
	'WATCHING_DESC',
	'LATEST_UPDATE_DATE_ASC',
	'LATEST_UPDATE_DATE_DESC',
] as const;

export type GoalDirectorySortAgg = (typeof GOAL_DIRECTORY_SORTS_AGG)[number];

export const DEFAULT_GOAL_SORTS: GoalDirectorySortAgg[] = [
	'WATCHING_DESC',
	'LATEST_UPDATE_DATE_DESC',
	'NAME_ASC',
];
